import React, { useLayoutEffect, useState, useEffect } from 'react';
import BetsOddsHeader from '../../common/BetsOddsHeader';
import PrematchContext from '../../contexts/PrematchContext';
import { LIST_BETS_HANDICAP_TYPES, MAX_COLUMNS } from '../../data/constants';
import { filterBetsByNumberOfOdds, filtraParametriche, getConfiguration, iconCategoryCssClass } from '../../data/utils';
import { getLabel } from '../../data/labels';
import { CustomCols } from '../../live/Live';
import { adjustOddsAlignment } from '../../tables-utils';
import PrematchTournamentMatch from './PrematchTournamentMatch';
import FavoriteTournamentToggle from './FavoriteTournamentToggle';

function PrematchTournamentMatches(props) {
    const prematchContext = React.useContext(PrematchContext);
    const customCols = React.useContext(CustomCols);
    const [closed, setClosed] = useState(false);
    const conf = getConfiguration();

    function openTournament() {
        prematchContext.toggleTournament(props.uniqueId, true);
    }

    function handleClose() {
        setClosed(true);
    }

    useLayoutEffect(() => {
        adjustOddsAlignment();
    });

    useEffect(() => {
        setClosed(false);
    }, [props.matches]);

    const match = props.matches[0];
    let matchBets = match.bets;
    let bets = [];
    let headerBets = [];
    bets = filtraParametriche(bets);
    bets = filtraParametriche(matchBets);
    bets = filterBetsByNumberOfOdds(bets, customCols);
    bets = bets.filter(bet => !LIST_BETS_HANDICAP_TYPES.includes(bet.tipoHandicap));
    if (match.betsById.size === 0 && matchBets.length > 1) {
        headerBets = bets;
        let nOdds = 0;
        matchBets.forEach(bet => {
            nOdds += bet.odds.length;
        });
        if (nOdds > MAX_COLUMNS) {
            headerBets = [];
        }
    } else {
        headerBets = bets;
    }

    const matches = props.matches.sort((a, b) => a.time.localeCompare(b.time));

    const firstMatch = matches[0];
    const icoTournament = iconCategoryCssClass(firstMatch.sportRef, firstMatch.categoryRef, firstMatch.icoTournament);

    let fiveColumnTemplate = false;
    if (match.gruppiScommessa.length <= 1) {
        fiveColumnTemplate = true;
    }

    return (!closed &&
        <>
       {conf.iwh && <div className="tabellaQuoteTorneo__wh d-flex align-items-center pl-1">
                    <FavoriteTournamentToggle className="ml-auto" uniqueId={props.uniqueId} />
                    <span className="d-centro-v maiuscolo w-100 pointer" onClick={openTournament}>
                        <div className={`img-fluid img-flags ico-cat mr-2 ${icoTournament}`}></div>
                        <p>{props.desc}</p>
                    </span>
                </div>}
        <div className="contenitore-table bg-bianco bordo-tondo" id={`prematch-matches-container${props.id}`}>
            <div className={`tabellaQuoteIntestazione text_s1 tabellaQuoteIntestazionePrematch tabellaQuoteIntestazionePrematch_template-2 mb-2${fiveColumnTemplate ? ' tabellaQuotePrematch_5col' : ''}`}>
                <div className="tabellaQuoteAlias d-flex justify-content-center align-items-center">{getLabel('prematch_page.torneo.tournament_day_header.alias')}</div>
                <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center pointer">
                    <p>{getLabel('prematch_page.torneo.tournament_day_header.time')}</p>
                </div>
                <div className="tabellaQuoteSquadre"></div>
                <div className="tabellaQuoteContenitoreQuotazioni d-flex justify-content-end align-items-center flex-grow-1">
                    <BetsOddsHeader bets={headerBets} matches={matches} />
                </div>
                <div className="tabellaQuoteStatistiche"></div>
                {!fiveColumnTemplate &&
                    <div className="tabellaQuoteAltre d-flex justify-content-center align-items-center"></div>
                }
                {!conf.iwh && <div className="tabellaQuoteTorneo d-flex align-items-center pl-1">
                    <i className="fa fa-times margine-dx align-self-center pointer" onClick={handleClose}></i>
                    <span className="d-centro-v maiuscolo w-100 pointer" onClick={openTournament}>
                        <div className={`img-fluid img-flags ico-cat mr-2 ${icoTournament}`}></div>
                        <p>{props.desc}</p>
                        <i className="fas fa-chevron-right"></i>
                    </span>
                </div>}
            </div>
            {matches.map(match =>
                <PrematchTournamentMatch key={match.id} match={match} aggregata={props.aggregata} isLive={false} openMatch={props.openMatch} />
            )}
        </div></>
    )
}

const PrematchTournamentMatchesMemo = React.memo(PrematchTournamentMatches, (prevProps, nextProps) => {
    if (prevProps.matches === nextProps.matches) {
        return true;
    }
    return false;
});

export default PrematchTournamentMatchesMemo;